<div class="modal-header">
    <h5 class="modal-title">New Multi-Year Agreement</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss();"></button>
</div>
<div class="modal-body">
    <form [formGroup]="myaForm">
        <div class="mb-3">
            <label for="CLIENT">Client</label>
            <input *ngIf="clientTypeaheadInput" id="CLIENT" type="text" class="form-control" formControlName="client"
                placeholder="Type to Search" [ngbTypeahead]="clientTypeaheadInput"
                (focus)="clientTypeaheadInputFocus$.next($any($event).target.value)"
                [resultFormatter]="clientResultFormatter" (selectItem)="selectClient($event);">
        </div>
        <div class="mb-3">
            <label for="SITE">Site</label>
            <div class="input-group">
                <select id="SITE" class="form-select" formControlName="site" required
                    [class.is-invalid]="site.invalid && (site.dirty || site.touched)">
                    <option *ngFor="let site of sites" [value]="site.id">{{site.address.street}} {{site.address.city}}
                        {{site.address.state}} {{site.address.postalCode}} ({{site.name}})</option>
                </select>
                <button *ngIf="showAddSiteButton" type="button" class="btn btn-primary ms-auto"
                    (click)="openNewSiteModal();" ngbTooltip="New Site">
                    <fa-icon [icon]="faPlus"></fa-icon>
                </button>
            </div>
            <div *ngIf="site.invalid && (site.dirty || site.touched)">
                <div *ngIf="site.errors.required" class="input-validation-msg">Site is required.</div>
            </div>
        </div>
        <div class="mb-3">
            <label for="START_YEAR">Start Year</label>
            <input id="START_YEAR" type="number" class="form-control" placeholder="202X" formControlName="startYear"
                min="1" required [class.is-invalid]="startYear.invalid && (startYear.dirty || startYear.touched)">
            <div *ngIf="startYear.invalid && (startYear.dirty || startYear.touched)">
                <div *ngIf="startYear.errors.required" class="input-validation-msg">Year is required.</div>
                <div *ngIf="startYear.errors.min" class="input-validation-msg">Year cannot be less than 1.</div>
            </div>
        </div>
        <div>
            <label for="MYA_LENGTH">Length (Years)</label>

            <select id="MYA_LENGTH" class="form-select" formControlName="myaLength" required
                [class.is-invalid]="myaLength.invalid && (myaLength.dirty || myaLength.touched)">
                <option value="" disabled selected>Select Length</option>

                <option *ngFor="let year of myaLengthOptions$ | async" [value]="year">
                    {{ year }} Year(s)
                </option>
            </select>

            <div *ngIf="myaLength.invalid && (myaLength.dirty || myaLength.touched)">
                <div *ngIf="myaLength.errors?.required" class="input-validation-msg">
                    Length is required.
                </div>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="addNewMya();">Save</button>
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss();">Close</button>
</div>